import { render, staticRenderFns } from "./lockSpaces.vue?vue&type=template&id=b0100ff2&scoped=true&"
import script from "./lockSpaces.vue?vue&type=script&lang=js&"
export * from "./lockSpaces.vue?vue&type=script&lang=js&"
import style0 from "./lockSpaces.vue?vue&type=style&index=0&id=b0100ff2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0100ff2",
  null
  
)

component.options.__file = "lockSpaces.vue"
export default component.exports